module.exports = __webpack_public_path__ + "static/media/new-logo-michpal-6.4771fdda.png";